export enum SESSION_STORAGE_KEYS {
  CONTACT_PERM = 'contact_perm',
  TWA_WS_URL = 'twaWsUrl',
  TWA_PORT = 'twaPort',
  IS_TWA = 'isTwa',
  REFRESH_COUNT = 'refreshCount',
  LOCATION_SEARCH = 'locationSearch',
}
